import { memo } from "react";

import AssistantMessage from "../AssistantMessage/AssistantMessage";
import { Box } from "@mui/material";
import { ChatMessageWithParts } from "src/views/assistant/types";
import UserMessage from "../UserMessage/UserMessage";

type ChatMessageProps = {
  "data-testid"?: string;
  dialogue: ChatMessageWithParts[];
  chatMessage: ChatMessageWithParts;
  sortedMessageGroup: ChatMessageWithParts[];
  messageGroupIdx: number;
  messageIndex: number;
  currentIndex?: number;
  isChatConnected: boolean;
  isTurnActive?: boolean;
  isChatMessageStreamStopped: boolean;
  isPreferredMessagePicked?: boolean;
  resendUserMessage: (id: string, text: string) => void;
  regenerateResponse: (id: string) => void;
  setAsPreferredMessage: (id: string) => void;
  handlePrev: () => void;
  handleNext: () => void;
};

const ChatMessage = ({
  "data-testid": dataTestId,
  dialogue,
  chatMessage,
  sortedMessageGroup,
  messageGroupIdx,
  messageIndex,
  currentIndex = 0,
  isChatConnected,
  isTurnActive = false,
  isChatMessageStreamStopped,
  isPreferredMessagePicked = false,
  resendUserMessage,
  regenerateResponse,
  setAsPreferredMessage,
  handlePrev,
  handleNext,
}: ChatMessageProps) => {
  // we are supporting old history format by looking at the 0th index vs setting a .type property on the object
  const isUser = chatMessage.type === "User";
  const isAssistant = chatMessage.type === "Assistant";
  const isAssistantText = chatMessage.contentParts?.length > 0;
  const showAssistantMessage = isAssistant && isAssistantText;

  return (
    <Box key={messageIndex} data-testid={dataTestId} width={"100%"}>
      {isUser && (
        <UserMessage
          messageGroupIdx={messageGroupIdx}
          messageIndex={messageIndex}
          dialogue={dialogue}
          chatMessage={chatMessage}
          isTurnActive={isTurnActive}
          resendUserMessage={resendUserMessage}
        />
      )}
      {showAssistantMessage && (
        <AssistantMessage
          messageGroupIdx={messageGroupIdx}
          messageIndex={messageIndex}
          currentIndex={currentIndex}
          chatMessage={chatMessage}
          dialogue={dialogue}
          sortedMessageGroup={sortedMessageGroup}
          isChatConnected={isChatConnected}
          isTurnActive={isTurnActive}
          isChatMessageStreamStopped={isChatMessageStreamStopped}
          isPreferredMessagePicked={isPreferredMessagePicked}
          regenerateResponse={regenerateResponse}
          setAsPreferredMessage={setAsPreferredMessage}
          handlePrev={handlePrev}
          handleNext={handleNext}
        />
      )}
    </Box>
  );
};
export default memo(ChatMessage);
